import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/svg/previous-w.svg")